import React from 'react'
import loader from '../../images/loader.gif';

const Loader = () => (
  <div className="loader">
    <img src={ loader } alt="Loader" title="loader" />
  </div>
)

export default Loader